import React from 'react';
import './style.css';

export const Header = () => {
    return (
        <div>
            <div className='header'>
                <div className='title'>
                    <h1>Controle Financeiro</h1>
                </div>
            </div>
        </div>
    )
};

export default Header;
